document.addEventListener("DOMContentLoaded", function () {
  
  const floatingBtn = document.getElementById("floatingAddToCart");
  const mainAddToCart = document.querySelector("form [type='submit']");
  const footer = document.querySelector(".footer");

  if (!floatingBtn || !mainAddToCart || !footer) return;

  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
  if (!isMobile) return;

  let isFloatingVisible = false;

  function updateFloatingButton() {
    const aRect = mainAddToCart.getBoundingClientRect();
    const footerRect = footer.getBoundingClientRect();

    const isAboveA = aRect.bottom < 0; // 页面滚过 A
    const isBelowA = aRect.top > window.innerHeight; // 页面还没到 A
    const isAVisible = aRect.top >= 0 && aRect.bottom <= window.innerHeight;

    const isFooterVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;

    if (isAVisible || isBelowA || isFooterVisible) {
      // 在 A 上面 或 A 可见 或 在 footer → 隐藏
      hideFloating();
    } else if (isAboveA && !isFooterVisible) {
      // 已滑过 A 且 footer 不在 → 显示
      showFloating();
    }
  }

  function showFloating() {
    if (!isFloatingVisible) {
      floatingBtn.style.display = 'block';
      floatingBtn.classList.add('fade-in-up');
      floatingBtn.classList.remove('fade-out-down');
      isFloatingVisible = true;
    }
  }

  function hideFloating() {
    if (isFloatingVisible) {
      floatingBtn.classList.remove('fade-in-up');
      floatingBtn.classList.add('fade-out-down');
      setTimeout(() => {
        floatingBtn.style.display = 'none';
      }, 300);
      isFloatingVisible = false;
    }
  }

  window.addEventListener("scroll", updateFloatingButton);
  window.addEventListener("resize", updateFloatingButton);

  // 初始触发
  updateFloatingButton();

  // 点击按钮 B = 模拟点击按钮 A，触发抽屉
  floatingBtn.addEventListener("click", () => {
    mainAddToCart.click();
  });
});